import { RootState } from 'store/types';
import { createSelector } from 'reselect';

export const navigationStateSelector = (state: RootState) => state.navigation;

export const navigationAllBreadCrumbsSelector = createSelector(
  navigationStateSelector,
  navigation => navigation?.breadCrumbs || []
);

export const currentNavigationWebStateSelector = createSelector(
  navigationStateSelector,
  navigation => navigation.webState || 'preload'
);
